import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import { sanitizeDescriptionHtml } from "./descriptionEditorConfig";

type Props = {
  open: boolean;
  eyebrow: string;
  title: string;
  subtitle: string;
  content: string;
  onClose: () => void;
};

const ViewDescriptionModal: React.FC<Props> = ({
  open,
  eyebrow,
  title,
  subtitle,
  content,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "6px",
          boxShadow: "0px 12px 32px rgba(15, 23, 42, 0.18)",
          maxWidth: 760,
        },
      }}
    >
      <div className="benefits-ptv-modal">
        <header className="benefits-ptv-modal-header">
          <div>
            <p className="benefits-ptv-modal-eyebrow">{eyebrow}</p>
            <h3>{title}</h3>
            <p className="benefits-ptv-modal-subtitle">{subtitle}</p>
          </div>
          <button
            type="button"
            className="benefits-ptv-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <Iconography icon="xmark" size={IconographySizes.Medium} />
          </button>
        </header>
        <DialogContent className="benefits-ptv-modal-content">
          <div
            className="benefits-description-preview"
            dangerouslySetInnerHTML={{
              __html:
                sanitizeDescriptionHtml(content) ||
                "<p>No description added.</p>",
            }}
          />
        </DialogContent>
      </div>
    </Dialog>
  );
};

export default ViewDescriptionModal;
